module.exports = __webpack_public_path__ + "static/media/stop.12ab1a0b.svg";